import contact from './lib/contact'
import rebox from './lib/rebox'
import { toggleBelowFold, scrollSpy, smoothScroll } from './lib/scroll'

$(document).ready(function () {
  contact('#contact-form--footer')
  rebox('.instanode-headstart-thumbimage')
  toggleBelowFold()
  // scrollSpy('.header-nav-sub:visible', {offset: 0})
  // smoothScroll('a[href^="#"]', {offset: 0})

$( ".neos-nodetypes-text-with-image " ).parent(".grid-content-col.col-12").addClass('no-padding');
})

$('.carousel').carousel({
    interval: false,
});

$(document).ready(function () {
    $(document).scroll(function () {
      var scroll = $(this).scrollTop()
      if (scroll > 0) {
        $('.header').addClass('fixed');
      } else {
        $('.header').removeClass('fixed');
      }
    })
  })

  $('.gallery-slider .neos-contentcollection').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          centerMode: true
        }
      },
      {
        breakpoint: 500,
        settings: {
          variableWidth: false
        }
      }
    ]
  });



// WEBPACK FOOTER //
// ./Private/Scripts/application.js